var __react_jsx__ = require('react');
var _J$X_ = (__react_jsx__["default"] || __react_jsx__).createElement;
(__react_jsx__["default"] || __react_jsx__).Fragment;
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgWarning = function SvgWarning(props) {
  return /*#__PURE__*/_J$X_("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/_J$X_("path", {
    fillRule: "evenodd",
    d: "M13.017 16.941c0 .56-.456 1.015-1.019 1.015-.562 0-1.019-.454-1.019-1.015 0-.56.457-1.014 1.02-1.014.562 0 1.018.454 1.018 1.014Zm-.51-2.029H11.49l-.51-5.073h2.038l-.51 5.073Zm-.509-10.086 8.459 15.16H3.54l8.458-15.16Zm0-1.826a.305.305 0 0 0-.243.18L2.052 20.555c-.133.243 0 .446.265.446H21.68c.285 0 .397-.203.265-.446L12.243 3.183A.306.306 0 0 0 11.999 3Z",
    clipRule: "evenodd"
  })));
};

export { SvgWarning as ReactComponent };
